import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

import queryResult from '@/store/modules/query-result'

export default new Vuex.Store({
  modules:{
    queryResult
  }
})
